import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import { PageContent, PageTitle } from 'nallian-shared-ui/lib/components';
import { TABS, INFINITE_SCROLL, APPS_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const AppsOverview = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('apps_plural')}</PageTitle>
      <PageContent>
        <Table
          infiniteScroll={INFINITE_SCROLL}
          resource={APPS_RESOURCE}
          url={apiRoutes.apps()}
          pageSize={50}
          idProp="tag"
          noUserSettings
          filtered
          sorted
        >
          <Actions.Link
            iconbutton
            width="2.5rem"
            icon="eye"
            align="center"
            url={`/apps/:id/${TABS.DETAILS}`}
          />
          <Params.String name="name" width="16rem" minWidth="16rem" grow noFilter />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow noFilter />
          <Menu width="3.5rem" align="center">
            <Actions.Delete url={apiRoutes.apps(':id')} label="removeApp" />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

AppsOverview.propTypes = {};
AppsOverview.defaultProps = {};

export default AppsOverview;
